import React from 'react';
import styled from 'styled-components';
import { Button } from 'antd';
import { CheckCircle } from '@styled-icons/material';
import { FlexRow } from '@shared/ui/Containers/FlexContainer';
import { ItemDetailsLabel } from '@ui/StyledComponents/inputs';
import HelpButton from 'shared/ui/Help/HelpButton';
import theme from '@config/theme';

const SettingRow = styled(FlexRow)`
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

const LabelWrapper = styled(FlexRow)`
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
`;

const ToggleButton = styled(Button)<{ $checked: boolean }>`
  font-size: 14px;
  font-weight: 600 !important;
  min-width: 128px;
  background-color: ${(props) => (props.$checked ? theme.palette.primary.hue : theme.palette.neutral[400])};
  border: 1px solid ${(props) => (props.$checked ? theme.palette.primary.hue : theme.palette.neutral[400])};
  color: ${theme.palette.neutral.white};
  border-radius: 8px;
  &:hover,
  &:active,
  &:focus {
    background-color: ${(props) => (props.$checked ? theme.palette.primary.D100 : theme.palette.neutral[500])};
    color: ${theme.palette.neutral.white};
    border: 1px solid ${(props) => (props.$checked ? theme.palette.primary.D100 : theme.palette.neutral[500])};
  }
`;

const CheckedIcon = styled(CheckCircle)`
  color: ${theme.palette.neutral.white};
  width: 20px;
  margin-right: 8px;
  margin-bottom: 2px;
`;

interface IComponent {
  label: string;
  helpMessage: string;
  value: boolean;
  storageKey: string;
  reloadRequired: boolean;
  callback: (key: string, value: boolean, reloadRequired: boolean) => void;
}

const BooleanSetting = ({
  label, storageKey, value, callback, helpMessage, reloadRequired = false,
}: IComponent) => {
  const onToggle = () => {
    callback(storageKey, !value, reloadRequired);
  };

  return (
    <SettingRow key={`setting-${storageKey}-row`}>
      <LabelWrapper>
        <ItemDetailsLabel>{label}</ItemDetailsLabel>
        <HelpButton style={{ marginBottom: 2 }} helpMessage={helpMessage} />
      </LabelWrapper>
      <ToggleButton $checked={value} onClick={onToggle}>
        {value && <CheckedIcon />}
        {value ? 'Enabled' : 'Disabled'}
      </ToggleButton>
    </SettingRow>
  );
};

export default BooleanSetting;
